import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { MODAL_HIDE, SNACKBAR_HIDE, MODAL_SHOW, MODAL_USER_SET_ETH_ADDRESS } from '../../../constants/action-types';

class UserPromptModalComponent extends Component {
    constructor(props) {
        super(props);
    }

    hideSnackbar(ev) {

        ev.preventDefault()
        this.props.closeSnackbar()

    }

    followSnackbarAction() {

        this.props.closeSnackbar()
        this.props.openUserSetEthAddressModal()

    }

    render() {
        return (
            <div id='snackbar' className={this.props.app.showSnackbar ? '' : 'hide'} onClick={this.followSnackbarAction.bind(this)}>
                <span className='icon icon-x' onClick={this.hideSnackbar.bind(this)}></span>
                <small>You must set your ETH address to recieve tokens later</small>
            </div>);
    }
}

const mapStateToProps = (state) => state

const mapDispatchToProps = (dispatch) => ({
    openUserSetEthAddressModal: () => { dispatch({type: MODAL_SHOW, modal: MODAL_USER_SET_ETH_ADDRESS }) },
    closeSnackbar: (email) => dispatch({ type: SNACKBAR_HIDE })
});


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UserPromptModalComponent)


// WEBPACK FOOTER //
// ./src/components/templates/snackbars/no-eth-address.js